import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SHARED_DEVICE_WARNING_THRESHOLD_SECONDS } from '@/constants/sharedDevice';

interface SharedDeviceTimeoutNotificationProps {
  remainingSeconds: number;
  onContinue: () => void;
}

/**
 * 共有端末の自動リセット警告通知コンポーネント
 * 残り秒数が閾値以下になったら表示される
 */
export const SharedDeviceTimeoutNotification = ({
  remainingSeconds,
  onContinue,
}: SharedDeviceTimeoutNotificationProps) => {
  const { t } = useTranslation();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const isOpenRef = useRef(false);

  // 残り秒数が閾値より大きい場合は表示しない
  const shouldShow =
    remainingSeconds <= SHARED_DEVICE_WARNING_THRESHOLD_SECONDS;

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (shouldShow && !isOpenRef.current) {
      dialog.showModal();
      isOpenRef.current = true;
    } else if (!shouldShow && isOpenRef.current) {
      dialog.close();
      isOpenRef.current = false;
    }
  }, [shouldShow]);

  return (
    <dialog
      ref={dialogRef}
      className="timeout-notification"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <div className="timeout-notification__content">
        <span className="timeout-notification__message">
          {t('shareDevice.timeout.message')}
        </span>
        <button onClick={onContinue} className="timeout-notification__btn">
          {t('shareDevice.timeout.continueButton')}
        </button>
      </div>
    </dialog>
  );
};
